export default __webpack_public_path__ + "static/media/KROM_Transparent_1.e0bf0c97.png";